module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE THIRTEENTH")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('big', [_vm._v("I")]), _vm._v(" want to first thank the Most High Creator for allowing me to begin and complete this twelve-book epic. When I started it, I had no idea where it was going or how long it would be. That just goes to show you that sometimes there is something bigger than you out there orchestrating things in a way you could not conceive of . . . therefore, with that said, this last book is in honor of the fantastic, cosmic beauty, love, and intelligence that is the alpha and the omega . . . referred to by many names, but the one source of all Divine. Thank you, Tua.")], 1), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I also thank the ancestors for guiding me with the whispers of angels, for the abundant blessings poured down on me . . . pressed down and overflowing. I thank the readers who all hung with me till the very end: Three Feathers Light, for her guidance on Atlantis; Bill Harvey, for his deep consciousness and readings he shared with me about all things metaphysical; and as always, the Street Team, whom I affectionately call “my Guardians,” bless you all for the love! Through this process, we literally became family. What a truly wonderful, extraordinary gift.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "linespace"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("ACKNOWLEDGMENTS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("* * *")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "para"
  }, [_vm._v("Special acknowledgment: As always, Manie Barron, coconspirator, creator, collaborator—"), _c('em', [_vm._v("big smile")]), _vm._v(" . . . I love you, man! Monique Patterson . . . lady . . . wow . . . we did it, huh? "), _c('em', [_vm._v("LOL! Thank you")]), _vm._v(" and all the fine folks at St. Martin’s Press. Plus I must give kudos to Denise Dorman and team at Write Brain Media for their creative PR fire, as well as to Walt Stone at Dream Forge Media for keeping the communication channels up on all Web sites. And most important, I want to thank my daughter who stood witness and gave me her love and support through it all! Much love.")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc306cec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgment.vue
// module id = 72
// module chunks = 0